import fr from 'facet-rest';
import PasswordInput from 'Components/ComponentLibrary/Components/Inputs/Password';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import BaseOverride from 'Overrides/Authentication/BaseOverride';

const PasswordResetOverride = fr.metaOverride({ base: BaseOverride })
  .typeOverride('string', {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        test: 'authentication-reset-password-email-input',
        name: 'email',
        id: 'email',
        type: 'email',
      },
    },
  })
  .nameOverride('password', {
    _component: () => PasswordInput,
    _customProps: {
      InputProps: {
        test: 'authentication-reset-password-new-password-input',
      },
    },
  })
  .done();

export default PasswordResetOverride;
